export const RECONCILIATION_SUBMIT_POPUP_LOADING_STATES = {
    CONFIGURATIONS_LOADING: "CONFIGURATIONS_LOADING",
    CONFIGURATIONS_READY: "CONFIGURATIONS_READY",
    DEPENDENT_FIELD_CHANGE_LOADING: "DEPENDENT_FIELD_CHANGE_LOADING",
    DEPENDENT_FIELD_CHANGE_READY: "DEPENDENT_FIELD_CHANGE_READY",
    SAVE_FORM_LOADING: "SAVE_FORM_LOADING",
    SAVE_FORM_READY: "SAVE_FORM_READY",
}

export const RECONCILIATION_SUBMIT_POPUP_STATES_MESSAGE_MAP = {
    [RECONCILIATION_SUBMIT_POPUP_LOADING_STATES.CONFIGURATIONS_LOADING]: "",
    [RECONCILIATION_SUBMIT_POPUP_LOADING_STATES.DEPENDENT_FIELD_CHANGE_LOADING]: "",
    [RECONCILIATION_SUBMIT_POPUP_LOADING_STATES.SAVE_FORM_LOADING]: "",
}

export const RECONCILIATION_FORM_NAMES = {
    FORMNAME: "ReconciliationForms",
    
}